/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component } from 'react'

const workerStatus = global.rootRequire('classes/globalStatus')
const { rxaget, autoConvertTime } = global.rootRequire('classes/ulti')


class OnOffGroup_ extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}

    this.currentGroupId = rxaget(props, 'groupId', '')
    this.countMemberOnl = 0
    
    if (props.arrUsers && props.arrUsers.constructor === Array && props.arrUsers.length > 0 && props.arrUsers.length < 100) {
      let countOnline = 1
      for(let userId of props.arrUsers) {
        if (userId && workerStatus.status[userId] && workerStatus.status[userId]['status']) {
          countOnline += 1
        }
      }
      this.countMemberOnl = countOnline
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    try {
      let flagReturn = false
      let groupId = rxaget(nextProps, 'groupId', '')
    
      if (rxaget(nextProps, 'rxUserStatus', false) !== rxaget(this.props, 'rxUserStatus', false) || (groupId !== this.currentGroupId)) {
        if (nextProps.arrUsers && nextProps.arrUsers.constructor === Array && nextProps.arrUsers.length > 0 && nextProps.arrUsers.length < 100) {
          this.currentGroupId = groupId
          let countOnline = 1
          for(let userId of nextProps.arrUsers) {
            if (userId && workerStatus.status[userId] && workerStatus.status[userId]['status']) {
              countOnline += 1
            }
          }
          this.countMemberOnl = countOnline
          flagReturn = true
        }
      }
      return flagReturn
    } catch(e) {
      return true
    }
  }

  render() {
    return (<React.Fragment>
      {(this.countMemberOnl > 1) && <>{(', ' + this.countMemberOnl + ' '+ translate('Online'))} </>}
    </React.Fragment>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  rxUserStatus: state.rxUserStatus
})

const mapDispatchToProps = {}

const OnOffGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnOffGroup_)

export default OnOffGroup